export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TOO MANY PROCEDURES. NOT ENOUGH VISUAL CLARITY.',
    body: 'Vascular access? Wound assessment? Medication verification? Emergency recognition? Some procedures involve multiple safety checks, anatomical references, and monitoring requirements. Having everything visually organized makes reviewing them easier.',
  },
  {
    title: "⚠️ YOU KNOW THE PROCEDURE—BUT WHERE'S YOUR REFERENCE?",
    body: 'Even experienced nursing professionals need to review equipment, clinical findings, assessment frameworks, and safety considerations. Finding clear, structured references shouldn\'t require searching through multiple resources.',
  },
  {
    title: '📚 YOUR NURSING REFERENCES ARE EVERYWHERE',
    body: "Assessment charts, injection diagrams, wound classifications, medication safety guides, monitoring tools, and clinical documentation templates. The information exists—but it's scattered when you need it.",
  },
  {
    title: '😩 STOP ORGANIZING YOUR CLINICAL REFERENCES FROM SCRATCH',
    body: 'Stop collecting disconnected nursing diagrams, procedure notes, and assessment checklists. Access one organized visual system covering six essential areas of professional nursing practice.',
  },
]
